import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ComunicacionService } from '../_services/comunicacion.service';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { DatePipe } from '@angular/common';
import { Novedad } from '../_models/novedad.model';
import { DialogMensajeComponent } from '../dialog-mensaje/dialog-mensaje.component';

@Component({
  selector: 'app-dialog-crear-editar-novedad',
  templateUrl: './dialog-crear-editar-novedad.component.html',
  styleUrls: ['./dialog-crear-editar-novedad.component.css'],
  providers: [DatePipe]
})
export class DialogCrearEditarNovedadComponent implements OnInit {

  novedadesForm!: FormGroup;
  loading = false;
  submitted = false;
  edit = false;
  fecha_min_fp!: Date;
  fecha_min_ff!: Date;
  errorFechaFin = false;
  usuarioLog: string;

  constructor(
    public dialogRef: MatDialogRef<DialogCrearEditarNovedadComponent>,
    @Inject(MAT_DIALOG_DATA) public novedad: Novedad | null,
    private fb: FormBuilder,
    private comunicacionService: ComunicacionService,
    private datePipe: DatePipe,
    private dialog: MatDialog
  ) {
    this.usuarioLog = JSON.parse(sessionStorage.getItem('currentUser') || '{}').usuario;
    const today = new Date();
    this.fecha_min_fp = today;
    this.fecha_min_ff = new Date(today.getFullYear(), today.getMonth(), today.getDate());

    if (novedad) {
      this.edit = true;
      // Convertir string a Date para que el datepicker funcione
      if (typeof novedad.fechaPublicacion === 'string') {
        novedad.fechaPublicacion = new Date(novedad.fechaPublicacion);
      }
      if (novedad.fechaFinPublicacion && typeof novedad.fechaFinPublicacion === 'string') {
        novedad.fechaFinPublicacion = new Date(novedad.fechaFinPublicacion);
      }
      this.fecha_min_fp = new Date(novedad.fechaPublicacion);
    }
  }

  ngOnInit(): void {
    this.buildForm();
  }

  private buildForm() {
    this.novedadesForm = this.fb.group({
      texto: [this.novedad?.texto || '', Validators.required],
      fecha_publicacion: [this.novedad?.fechaPublicacion || this.fecha_min_fp, Validators.required],
      fecha_fin: [this.novedad?.fechaFinPublicacion || null]
    });
  }

  actualizarFechaFin(event: MatDatepickerInputEvent<Date>) {
    if (event.value) {
      this.fecha_min_ff = new Date(event.value.getFullYear(), event.value.getMonth(), event.value.getDate());
    }
  }

  cancelar() {
    this.dialogRef.close();
  }

  onSubmit() {
    this.submitted = true;
    this.errorFechaFin = false;

    const fechaInicio = this.novedadesForm.value.fecha_publicacion;
    const fechaFin = this.novedadesForm.value.fecha_fin;

    if (!fechaInicio) return;
    const inicio = new Date(fechaInicio);
    inicio.setHours(0, 0, 0, 0);

    const fin = fechaFin ? new Date(fechaFin) : null;
    if (fin) fin.setHours(0, 0, 0, 0);
    console.log("fin < inicio",fin < inicio)
    if (fin && fin < inicio) {
      this.errorFechaFin = true;
      return;
    }

    if (this.novedadesForm.valid) {
      this.loading = true;
      const formValue = this.novedadesForm.value;
      
      const payload = {
        idComunicacion: this.novedad?.idComunicacion || undefined,
        usuarioEstado: this.usuarioLog,
        texto: formValue.texto,
        fechaPublicacion: this.datePipe.transform(formValue.fecha_publicacion, 'medium')!,
        fechaFinPublicacion: formValue.fecha_fin ? this.datePipe.transform(formValue.fecha_fin, 'medium')! : undefined
      };

      if (this.edit) {
        this.comunicacionService.modificarNovedad(payload).subscribe({
          next: res => this.mostrarModalResultado(res),
          error: err => {
            console.error(err);
            this.loading = false;
          }
        });
      } else {
        this.comunicacionService.agregarNovedad(payload).subscribe({
          next: res => this.mostrarModalResultado(res),
          error: err => {
            console.error(err);
            this.loading = false;
          }
        });
      }
    }
  }

  private mostrarModalResultado(res: any) {
    this.loading = false;
    this.dialog.open(DialogMensajeComponent, {
      width: '500px',
      data: res
    }).afterClosed().subscribe(() => {
      if (res.ok) this.dialogRef.close(true);
    });
  }
}
